export default __webpack_public_path__ + "static/media/BookQuest1.ad10a924.jpg";